<template>
  <h2 class="p-login-form__title">
    {{ text }}
  </h2>
</template>

<script>
export default {
  props: {
    text: String,
  },
}
</script>
